import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { CASE_STUDIES_ROUTES } from '../constants/routes.constants'
import { z } from 'zod'

const caseStudySearchSchema = z.object({
  page: z.coerce.number().int().positive().catch(1),
  pageSize: z.coerce.number().int().positive().catch(10),
  title: z.string().optional(),
  status: z.string().optional(),
})

import { appLayoutRoute } from '@/core/router/layouts'
const parentRoute = appLayoutRoute

const caseStudiesRoute = createRoute({
  path: CASE_STUDIES_ROUTES.INDEX,
  getParentRoute: () => parentRoute,
  validateSearch: (search) => caseStudySearchSchema.parse(search),
  component: lazyRouteComponent(() =>
    import('../pages').then(m => ({ default: m.CaseStudiesPage }))
  ),
})

const caseStudiesCreateRoute = createRoute({
  path: CASE_STUDIES_ROUTES.CREATE,
  getParentRoute: () => parentRoute,
  component: lazyRouteComponent(() =>
    import('../pages').then(m => ({ default: m.CaseStudyCreatePage }))
  ),
})

const caseStudiesEditRoute = createRoute({
  path: CASE_STUDIES_ROUTES.EDIT,
  getParentRoute: () => parentRoute,
  component: lazyRouteComponent(() =>
    import('../pages').then(m => ({ default: m.CaseStudyEditPage }))
  ),
})

const caseStudiesViewRoute = createRoute({
  path: CASE_STUDIES_ROUTES.VIEW,
  getParentRoute: () => parentRoute,
  component: lazyRouteComponent(() =>
    import('../pages').then(m => ({ default: m.CaseStudyViewPage }))
  ),
})

const caseStudiesRoutes = [
  caseStudiesRoute, 
  caseStudiesCreateRoute, 
  caseStudiesEditRoute,
  caseStudiesViewRoute
]

export default caseStudiesRoutes
